import Axios from 'axios'

import { SERVER_BASE_URL } from './baseUrl'

export const createDisponibilite = async (token: string, data: string) => {
  try {
    const response = await Axios.post(
      `${SERVER_BASE_URL}api/disponibilites`,
      { date: data },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const getDisponibiliteByUser = async (token: string) => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/disponibilites`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const deleteDisponibilite = async (token: string, id: number) => {
  try {
    const response = await Axios.delete(`${SERVER_BASE_URL}api/disponibilites/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
